import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Send, Loader2 } from "lucide-react";
import PageHeader from "./PageHeader";
import bannerThreeImg from "../assets/images/panner/3.jpeg";
import { contactInfo } from "../utils/contactInfoDummy";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
const Contact = () => {
  const form = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  // call inquiry api

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // 🟢 3️⃣ Send Email (Existing EmailJS)
      await emailjs.sendForm(serviceID, templateID, form.current, publicKey);

      // alert("Inquiry Sent Successfully ✅");
      toast.success("Inquiry Sent Successfully");
      e.target.reset();
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to send inquiry");
    }

    setIsLoading(false);
  };

  return (
    <div className="bg-slate-50 min-h-screen">
      <PageHeader
        title="Get in Touch"
        subtitle="Our team of experts is ready to assist you with product inquiries, custom formulations, and global supply chain solutions."
        bgImage={bannerThreeImg}
      />

      <div className="container mx-auto px-6 py-20">
        {/* Contact Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-16">
          {contactInfo.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="bg-white p-8 rounded-xl shadow-lg border border-slate-100 hover:shadow-xl transition-all group"
            >
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 bg-${item.color}-50 text-${item.color}-600 group-hover:scale-110 transition-transform`}
              >
                {item.icon}
              </div>
              <h3 className="text-card mb-3">{item.title}</h3>
              {item.details.map((line, i) => (
                <p key={i} className="text-body text-sm">
                  {line}
                </p>
              ))}
            </motion.div>
          ))}
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:w-full bg-white rounded-2xl shadow-xl p-8 border border-slate-100"
          >
            <h2 className="text-section mb-6">Send us a Message</h2>
            <form ref={form} onSubmit={sendEmail} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="group">
                  <label className="block text-sm font-semibold text-slate-700 mb-2">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-2 focus:ring-secondary/20 outline-none transition-all placeholder:text-slate-400"
                    placeholder="John Doe"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">
                    Business Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-2 focus:ring-secondary/20 outline-none transition-all placeholder:text-slate-400"
                    placeholder="john@company.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">
                    Company Name
                  </label>
                  <input
                    type="text"
                    name="company_name"
                    className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-2 focus:ring-secondary/20 outline-none transition-all placeholder:text-slate-400"
                    placeholder="Company Ltd"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">
                    Subject
                  </label>
                  <select
                    name="subject"
                    className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-2 focus:ring-secondary/20 outline-none transition-all bg-white text-slate-600"
                  >
                    <option>Product Inquiry</option>
                    <option>Custom Formulation</option>
                    <option>Partnership Proposal</option>
                    <option>Technical Support</option>
                    <option>Regulatory Compliance</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Message
                </label>
                <textarea
                  name="message"
                  required
                  rows="5"
                  className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-2 focus:ring-secondary/20 outline-none transition-all placeholder:text-slate-400"
                  placeholder="Tell us about your project requirements..."
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className={`w-full py-4 bg-gradient-to-r from-primary to-secondary text-white font-bold rounded-lg hover:shadow-lg hover:to-primary transition-all flex items-center justify-center gap-2 transform active:scale-95 ${
                  isLoading ? "opacity-70 cursor-not-allowed" : ""
                }`}
              >
                {isLoading ? (
                  <>
                    Sending... <Loader2 className="animate-spin" size={20} />
                  </>
                ) : (
                  <>
                    Send Message <Send size={20} />
                  </>
                )}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
